export default __webpack_public_path__ + "static/media/Community-Acquired-Pneumonia-1.5b936a58.jpg";